import React, { useState } from "react";
import CourseCard from "../../browse-courses/BrowseCourses/CourseCard";
import ManageCoursesLink from "~/components/general/ManageCoursesLink";
import { posthogEventCourseViewed } from "~/utils/posthog/courses";

const Group = ({
  courses = [],
  defaultDisplayCount = 3,
  displayManageCoursesLink,
  description,
  positionOnPage,
  showClasses = false,
  title,
  type,
}) => {
  const [expanded, setExpanded] = useState(false);
  const coursesToDisplay = expanded
    ? courses
    : courses.slice(0, defaultDisplayCount);

  const handleCourseClick = (course, positionInGroup) => {
    posthogEventCourseViewed({
      triggerId: "view-courses-course-card",
      course,
      viewCoursesContext: {
        groupExpanded: expanded,
        groupPosition: positionOnPage,
        groupType: type,
        positionInGroup,
      },
    });
    window.location = `/explorer.php?coid=${course.coid}`;
  };

  return (
    <div className="flex flex-col items-start gap-5">
      <div className="flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex h-14 flex-col justify-between gap-1">
          <div className="flex items-center gap-3">
            <h2 className="m-0 text-xl font-bold">{title}</h2>
            <span className="rounded-md bg-gray-200 px-2 py-0.5 text-xs font-bold text-gray-600">
              {courses.length}
            </span>
          </div>
          <p className="m-0 text-sm text-gray-700">{description}</p>
        </div>
        {displayManageCoursesLink && (
          <ManageCoursesLink className="px-4 text-base" />
        )}
      </div>
      <div className="grid w-full grid-cols-1 gap-4 md:auto-rows-fr md:grid-cols-2 lg:grid-cols-3">
        {coursesToDisplay.map((course, index) => (
          <CourseCard
            key={course.coid}
            className="md:min-h-36"
            course={course}
            onClick={() => handleCourseClick(course, index + 1)}
            showClasses={showClasses}
          />
        ))}
        {courses.length === 0 && (
          <div className="grid h-36 place-content-center md:col-span-2 lg:col-span-3">
            <span className="text-2xl font-semibold text-gray-300">
              No courses found
            </span>
          </div>
        )}
      </div>
      {courses.length > 3 && (
        <span
          className="cursor-pointer px-1 text-blue-500 underline underline-offset-4 hover:decoration-[3px]"
          onClick={() => setExpanded((s) => !s)}
        >
          {expanded ? "Show less" : "Show all"}
        </span>
      )}
    </div>
  );
};

export default Group;
